import React, { useState, useRef } from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import { Button, Modal, Box, Grid } from '@mui/material';
import styles from '../CheckpointCard.module.css';

interface CheckpointSignatureResponseProps {
	uppy: any;
	saveSignatureCallback: () => void;
}

const CheckpointSignatureResponse = ({
	uppy,
	saveSignatureCallback,
}: CheckpointSignatureResponseProps) => {
	const [open, setOpen] = useState(false);
	const sigCanvasRef = useRef<ReactSignatureCanvas>(null);

	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	const clearCanvas = () => {
		sigCanvasRef?.current?.clear();
	};

	const saveSignature = () => {
		const canvas = sigCanvasRef?.current?.getTrimmedCanvas();
		var timestamp = Date.now();
		canvas?.toBlob((blob: any) => {
			if (!blob) return console.error('Error saving signature');
			const signatureFile = new File(
				[blob],
				`signature_${timestamp}.png`,
				{
					type: 'image/png',
				},
			);

			const uppyFile = {
				name: signatureFile.name,
				type: signatureFile.type,
				data: signatureFile,
				source: 'local',
				isRemote: false,
			};
			uppy.addFile(uppyFile);
			saveSignatureCallback();
		}, 'image/png');

		handleClose(); // close the modal after saving the signature
	};

	return (
		<>
			<Button onClick={handleOpen} variant="contained">
				Take Signature
			</Button>
			<Modal open={open}>
				<>
					<Box className={styles.sigContainer}>
						<ReactSignatureCanvas
							ref={sigCanvasRef}
							penColor="green"
							canvasProps={{
								className: styles.sigPad,
							}}
						/>
					</Box>
					<Grid
						style={{
							height: '60px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								width: '100%',
								maxWidth: '500px',
								margin: '1rem',
							}}
						>
							<Button variant="contained" onClick={handleClose}>
								Back
							</Button>
							<Button variant="contained" onClick={saveSignature}>
								Save
							</Button>
							<Button variant="contained" onClick={clearCanvas}>
								Clear
							</Button>
						</Box>
					</Grid>
				</>
			</Modal>
		</>
	);
};

export default CheckpointSignatureResponse;
